import { Model as s } from "../../../../model.js";
class e extends s {
  constructor(a) {
    super(), this.status = a.status, this.timestamp = a.timestamp, this.amount = a.amount, this.currency = a.currency, this.reason = a.reason, this.description = a.description, this.payRefundId = a.payRefundId, this.payRefundBalanceTxId = a.payRefundBalanceTxId, this.feeTransactionId = a.feeTransactionId;
  }
}
export {
  e as TicketHistoryRefundModel
};
//# sourceMappingURL=ticketHistoryRefund.model.js.map
